import React, { useState, useEffect } from 'react';

const EditJobModal = ({ job, onSave, onClose }) => {
  const [jobData, setJobData] = useState(job);

  useEffect(() => {
    setJobData(job);
  }, [job]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobData({ ...jobData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(jobData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white border border-black p-8 w-full max-w-md">
        <h2 className="text-xl font-bold text-black mb-6 border-b border-black pb-3">Edit Job</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-5">
            <label htmlFor="title" className="block text-sm font-medium text-black mb-2">Job Title</label>
            <input
              type="text"
              id="title"
              name="title"
              value={jobData.title}
              onChange={handleChange}
              className="w-full px-1 py-2 border-b-2 border-gray-300 focus:border-yellow-400 focus:outline-none transition-colors"
            />
          </div>
          <div className="mb-5">
            <label htmlFor="location" className="block text-sm font-medium text-black mb-2">Location</label>
            <input
              type="text"
              id="location"
              name="location"
              value={jobData.location}
              onChange={handleChange}
              className="w-full px-1 py-2 border-b-2 border-gray-300 focus:border-yellow-400 focus:outline-none transition-colors"
            />
          </div>
          <div className="mb-5">
            <label htmlFor="description" className="block text-sm font-medium text-black mb-2">Job Description</label>
            <textarea
              id="description"
              name="description"
              value={jobData.description || ''}
              onChange={handleChange}
              rows="4"
              className="w-full px-1 py-2 border-b-2 border-gray-300 focus:border-yellow-400 focus:outline-none transition-colors"
            ></textarea>
          </div>
          <div className="mb-6">
            <label htmlFor="status" className="block text-sm font-medium text-black mb-2">Status</label>
            <select
              id="status"
              name="status"
              value={jobData.status}
              onChange={handleChange}
              className="w-full px-1 py-2 border-b-2 border-gray-300 focus:border-yellow-400 focus:outline-none appearance-none bg-white transition-colors"
            >
              <option value="Active">Active</option>
              <option value="Closed">Closed</option>
            </select>
          </div>
          <div className="flex justify-end gap-4 mt-8 pt-4 border-t border-black">
            <button type="button" onClick={onClose} className="py-2 px-6 border border-black text-black font-medium hover:bg-gray-100">
              Cancel
            </button>
            <button type="submit" className="py-2 px-6 bg-black text-white font-medium hover:bg-gray-800">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditJobModal;
